import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { NotificationService } from './shared/services/notification/notification.service';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly notificationService = inject(NotificationService);
  private readonly messageService = inject(MessageService);
  private toastSub?: Subscription;

  ngOnInit(): void {
    this.toastSub = this.notificationService.messages$.subscribe(msg => {
      this.messageService.add({
        severity: msg.severity,
        summary: msg.summary,
        detail: msg.detail,
        life: 5000,
      });
    });
  }

  ngOnDestroy(): void {
    this.toastSub?.unsubscribe();
  }
}
